// Precio de la carta: hasta 500 palabras, precio plano de $20.000. De 500 a 750
// palabras escala en línea recta hasta $25.000, y de ahí sigue subiendo a la
// misma pendiente (~$20/palabra extra).
export const LETTER_PRICE_FLOOR = 20000;
export const FLOOR_WORD_LIMIT = 500;
export const PRICE_CEILING_WORDS = 750;
export const PRICE_CEILING_VALUE = 25000;
export const PRICE_PER_WORD_ABOVE_FLOOR =
  (PRICE_CEILING_VALUE - LETTER_PRICE_FLOOR) / (PRICE_CEILING_WORDS - FLOOR_WORD_LIMIT);

export const POLAROID_PACK_PRICE = 2500;

// Puntos de entrega. Los 4 en persona son "por ahora" y sin cargo; la moto
// mensajería es la alternativa paga; Terrazas de Mayo trae 10% off en vez de
// sumar costo.
export const ENVIO_OPTIONS = [
  { id: "san-miguel", label: "San Miguel Centro", price: 0, discountPercent: 0 },
  { id: "estacion-urquiza", label: "Estación (línea Urquiza)", price: 0, discountPercent: 0 },
  { id: "unahur", label: "UNaHur", price: 0, discountPercent: 0 },
  { id: "unicenter", label: "Unicenter", price: 0, discountPercent: 0 },
  { id: "terrazas-mayo", label: "Shopping Terrazas de Mayo", price: 0, discountPercent: 10 },
  { id: "moto", label: "Moto mensajería", price: 8000, discountPercent: 0 },
];

export function countWords(text) {
  const trimmed = (text || "").trim();
  return trimmed ? trimmed.split(/\s+/).length : 0;
}

export function estimateLetterPrice(wordCount) {
  if (wordCount <= FLOOR_WORD_LIMIT) return LETTER_PRICE_FLOOR;
  const raw = LETTER_PRICE_FLOOR + PRICE_PER_WORD_ABOVE_FLOOR * (wordCount - FLOOR_WORD_LIMIT);
  return Math.round(raw / 100) * 100;
}

export function getEnvioOption(envioId) {
  return ENVIO_OPTIONS.find((o) => o.id === envioId) || ENVIO_OPTIONS[0];
}

// Recalcula el total completo a partir de datos crudos (texto de la carta,
// id de entrega, cantidad de paquetes de Polaroid). Se usa tanto en el
// frontend (para mostrar el precio en vivo) como en el servidor (que nunca
// debe confiar en precios que mande el cliente).
export function computeTotal({ wordCount, envioId, polaroidPacks }) {
  const estimatedPrice = estimateLetterPrice(wordCount);
  const envioOption = getEnvioOption(envioId);
  const safePolaroidPacks = Math.max(0, Math.min(6, Math.round(polaroidPacks) || 0));
  const polaroidPrice = safePolaroidPacks * POLAROID_PACK_PRICE;
  const subtotal = estimatedPrice + envioOption.price + polaroidPrice;
  const discountAmount = Math.round((subtotal * (envioOption.discountPercent || 0)) / 100 / 100) * 100;
  const totalPrice = subtotal - discountAmount;
  return {
    estimatedPrice,
    envioOption,
    polaroidPacks: safePolaroidPacks,
    polaroidPrice,
    subtotal,
    discountAmount,
    totalPrice,
  };
}

export function formatArs(n) {
  return n.toLocaleString("es-AR");
}
